import React from 'react';
import { Grid, Autocomplete, TextField, Typography } from '@mui/material';
import { format } from 'date-fns';
import styles from './IncidentTab.module.css';
import { useScheduleContext } from 'containers/pages/CANguard/context/ScheduleProvider';

interface PatrolSelectionProps {
	selectedPatrol: ScheduleAssignment | null;
	handleSelectedPatrolChange: (patrol: ScheduleAssignment | null) => void;
	selectedPatrolInputError: string | undefined;
}

const PatrolSelection: React.FC<PatrolSelectionProps> = (props) => {
	const { schedule } = useScheduleContext();
	const filteredPatrols = schedule.filter(
		(patrol) => patrol.type !== 'Incident',
	);
	return (
		<Grid item className={styles.sectionContainer}>
			<Typography component="div">
				Choose which patrol the incident occurred in:
			</Typography>
			<Autocomplete
				id="Patrols"
				options={filteredPatrols}
				getOptionLabel={(patrol) =>
					`${format(
						new Date(patrol.start_time),
						'hh:mm a (MMM dd) ',
					)} - ${patrol.cust_name} - ${patrol.address}`
				}
				value={props.selectedPatrol}
				onChange={(e, newValue) =>
					props.handleSelectedPatrolChange(newValue)
				}
				groupBy={(option) => {
					if (option.timeAtWhichGuardCanBeginPatrol < new Date()) {
						return 'Ongoing Patrols';
					} else {
						return 'Upcoming Patrols';
					}
				}}
				getOptionDisabled={(option) =>
					!(option.timeAtWhichGuardCanBeginPatrol < new Date())
				}
				renderInput={(params) => (
					<TextField
						{...params}
						label="Choose Patrol"
						variant="outlined"
						fullWidth
						error={!!props.selectedPatrolInputError}
						helperText={props.selectedPatrolInputError}
					/>
				)}
			/>
		</Grid>
	);
};

export default PatrolSelection;
